import { render, staticRenderFns } from "./DashSidebar.vue?vue&type=template&id=d34dd104"
import script from "./DashSidebar.vue?vue&type=script&lang=ts"
export * from "./DashSidebar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports